export class SpeedDetectorService {

	public detectSpeed(): void {
		if (window.addEventListener) {
			window.addEventListener('load', () => this.initiateSpeedDetection(), { once: true });
		}
	}

	private async initiateSpeedDetection(): Promise<void> {
		const lastSpeedMeasureTime = localStorage.getItem("speed-measure-time");
		const now = Date.now();

		if (lastSpeedMeasureTime) {
			const lastSpeedMeasureTimeNumber = Number(lastSpeedMeasureTime);

			// Ensure 8-hour interval before next test
			if (now - lastSpeedMeasureTimeNumber < 8 * 60 * 60 * 1000) {
				return;
			}
		}

		// Wait 30 seconds before running the test
		setTimeout(async () => {
			try {
				console.log("Starting speed test...");

				await this.measureDownloadSpeed();
				await this.measureUploadSpeed();

				console.log("Speed test completed.");
				localStorage.setItem('speed-measure-time', Date.now().toString());
			} catch (error) {
				console.error("Speed test failed:", error);
				localStorage.setItem('speed-measure-time', Date.now().toString());
			}
		}, 30_000);
	}


	private async measureDownloadSpeed(): Promise<void> {
		const imageUrl = 'images/polygonum_bistorta.jpg';
		const downloadSize = 7_300_000; // 7.3 MB in bytes

		try {
			const startTime = performance.now();

			// Fetch image to avoid cache issues
			const response = await fetch(imageUrl, {cache: 'no-store'});

			if (!response.ok) {
				console.error('Download speed test failed:', response.status);
				localStorage.setItem('download-speed-in-mbps', 'N/A');
				return;
			}

			await response.blob(); // Ensure full download

			const endTime = performance.now();
			const durationSeconds = (endTime - startTime) / 1000;

			// Speed calculations
			const speedMbps = ((downloadSize * 8) / (durationSeconds * 1_000_000)).toFixed(2);

			console.log(`Download speed: ${speedMbps} Mbps`);

			// Store in localStorage
			localStorage.setItem('download-speed-in-mbps', speedMbps);
		} catch (error) {
			console.error('Download speed test failed:', error);
			localStorage.setItem('download-speed-in-mbps', 'N/A');
		}
	}

	private async measureUploadSpeed(): Promise<void> {
		const blobSize = 1024 * 500;
		const blob = new Blob(['0'.repeat(blobSize)], {type: 'application/octet-stream'});

		try {
			const startTime = performance.now();
			const response = await fetch('upload-speed-test', {method: 'POST', body: blob});
			const endTime = performance.now();

			if (!response.ok) {
				console.error(`Upload failed with status: ${response.status}`);
				localStorage.setItem('upload-speed-in-mbps', 'N/A');
				return;
			}

			const durationSeconds = (endTime - startTime) / 1000;
			const speedMbps = ((blob.size * 8) / (durationSeconds * 1_000_000)).toFixed(2);

			console.log(`Upload speed: ${speedMbps} Mbps`);
			localStorage.setItem('upload-speed-in-mbps', speedMbps);

		} catch (error) {
			console.error('Upload speed test failed:', error);
			localStorage.setItem('upload-speed-in-mbps', 'N/A');
		}
	}
}
